import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { ActionsSubject, select, Store } from '@ngrx/store';
import { combineLatest, Observable, ReplaySubject } from 'rxjs';
import {
    filter,
    map,
    take,
    takeWhile,
    tap,
    withLatestFrom
} from 'rxjs/operators';
import { SelectItem } from '../../../shared';
import { LoggingService } from '../../../shared/services/logging';
import * as fromShared from '../../../shared';
import * as fromUser from '../../../user-info';
import * as fromExpense from '../../store';
import {
    SetEmployeesWithHours,
    getEmployeesWithHours,
    getContractorsWithHours,
    GetEmployeesWithHours,
    GetContractorsWithHours,
    SendHours,
    SendBills,
    getEmployeesWithPurchases,
    GetEmployeesWithPurchases,
    SendPurchases
} from '../../store';
import { ofType } from '@ngrx/effects';

@Component({
    selector: 'ef-send-purchases-container',
    templateUrl: './send-purchases-container.component.html',
    styleUrls: ['./send-purchases-container.component.scss'],
    standalone: false
})
export class SendPurchasesContainerComponent
    implements OnInit, AfterViewInit, OnDestroy
{
    process$: Observable<fromShared.Process>;
    private filterSubject = new ReplaySubject<{
        StartDate: Date;
        EndDate: Date;
        Resend: boolean;
    }>(1);
    private sendPurchasesSubject = new ReplaySubject<{
        items: SelectItem[];
        sendImages: boolean;
    }>(1);
    public items$: Observable<SelectItem[] | undefined>;
    public userInfo$: Observable<fromUser.IUserInfo>;
    public resend$: Observable<boolean>;
    public IsLoading = true;
    private active = true;

    constructor(
        private store: Store,
        private log: LoggingService,
        private dispatcher: ActionsSubject
    ) {}
    ngOnDestroy(): void {
        this.active = false;
    }
    ngOnInit(): void {
        this.process$ = this.store.pipe(select(fromShared.selectCurrent));
        this.setupObservables();
        this.setupSubscriptions();
    }
    ngAfterViewInit(): void {
        this.store.dispatch(new SetEmployeesWithHours([])); //clear cache
    }
    setupObservables(): void {
        this.userInfo$ = this.store.pipe(select(fromUser.getUserInfo));
        this.resend$ = this.filterSubject.pipe(map(filter => filter.Resend));
    }
    setupSubscriptions(): void {
        this.items$ = this.store.pipe(
            select(getEmployeesWithPurchases),
            map(items => {
                // this.IsLoading = false;
                return items?.map(item => ({
                    label: item.EmployeeName,
                    value: item.EmployeeListID
                }));
            })
        );
        this.store
            .pipe(
                select(getEmployeesWithPurchases),
                // filter(items => (items?.length ?? 0) > 0),
                take(1)
            )
            .subscribe(() => (this.IsLoading = false));
        this.filterSubject
            .pipe(takeWhile(() => this.active))
            .subscribe(value => {
                this.store.dispatch(new GetEmployeesWithPurchases(value));
            });
        this.sendPurchasesSubject
            .pipe(
                takeWhile(() => this.active),
                withLatestFrom(this.filterSubject),
                tap()
            )
            .subscribe(([send, filter]) => {
                this.IsLoading = true;
                send.items.forEach(item => {
                    this.store.dispatch(
                        new SendPurchases({
                            EmployeeListID: item.value,
                            startDate: filter.StartDate,
                            endDate: filter.EndDate,
                            Resend: filter.Resend,
                            sendImages: send.sendImages
                        })
                    );
                });
            });
        this.dispatcher
            .pipe(
                ofType(fromExpense.ActionTypes.SendPurchasesSuccess),
                takeWhile(() => this.active),
                tap(action =>
                    this.log.verbose({
                        type: 'SendPurchasesContainerComponent:SendPurchasesSuccess$',
                        action
                    })
                )
            )
            .subscribe(() => (this.IsLoading = false));

        this.dispatcher
            .pipe(
                ofType(fromShared.Errors.ErrorsSidenavActionTypes.SetErrors),
                takeWhile(() => this.active)
            )
            .subscribe(() => (this.IsLoading = false));
    }
    onFilter(value: { StartDate: Date; EndDate: Date; Resend: boolean }) {
        this.log.verbose({
            type: 'SendPurchasesContainerComponent:onFilter',
            value
        });
        this.filterSubject.next(value);
    }
    onSendPurchases($event: { items: SelectItem[]; sendImages: boolean }) {
        this.log.verbose({
            type: 'SendPurchasesContainerComponent:onSendPurchases',
            $event
        });
        this.sendPurchasesSubject.next($event);
    }
}
